import { render, staticRenderFns } from "./RealLifeTraining.vue?vue&type=template&id=6cfbdc7a&scoped=true"
import script from "./RealLifeTraining.vue?vue&type=script&lang=js"
export * from "./RealLifeTraining.vue?vue&type=script&lang=js"
import style0 from "./RealLifeTraining.vue?vue&type=style&index=0&id=6cfbdc7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cfbdc7a",
  null
  
)

export default component.exports